export default __webpack_public_path__ + "static/media/logo.d391853f.png";